import { EmptyState } from './EmptyState';
import { btnSecondary } from './styles';
import type { IconComponent } from '../../ui/icon';
type FailedProps = {
  /** De hele zin, bijv. "De bestellingen konden niet laden". */
  title: string;
  onRetry: () => void;
  /** 'block': een eigen vlak (lijsten, pagina's); 'inline': één regel in een paneel. */
  variant?: 'block' | 'inline';
  icon?: IconComponent;
  /** Alleen 'block': een eigen uitleg, bijv. dat er niets verloren is. */
  text?: string;
  className?: string;
};

/**
 * Laden lukte niet: overal in het beheer dezelfde woorden en dezelfde knop. Zegt wat er mis is
 * en biedt meteen "Opnieuw proberen"; nooit een leeg scherm.
 */
export function LoadFailed({
  title,
  onRetry,
  variant = 'block',
  icon,
  text = 'Controleer je verbinding en probeer het opnieuw.',
  className = ''
}: FailedProps) {
  if (variant === 'inline') return <p role="alert" className={`text-[13px] text-muted ${className}`} data-id="element-5016" data-mp="27ajng0rmmq1s">
        {title}.{' '}
        <button type="button" onClick={onRetry} className="text-clay underline underline-offset-2 hover:text-ink" data-id="element-5017" data-mp="2c9d607lrt78t">
          Opnieuw proberen
        </button>
      </p>;
  return <EmptyState icon={icon} className={className} title={title} text={text} action={<button type="button" onClick={onRetry} className={btnSecondary} data-id="element-5019" data-mp="3ba1cko9qc98n">
          Opnieuw proberen
        </button>} data-id="element-5018" data-mp="2xccrpgfnx23l" />;
}

/** Eén regel "Laden…" in een paneel, voor schermlezers als status. */
export function LoadingLine({
  label = 'Laden…',
  className = ''
}: {
  label?: string;
  className?: string;
}) {
  return <p role="status" className={`text-[13px] text-muted ${className}`} data-id="element-5020" data-mp="2sd9nfy7iazwo">
      {label}
    </p>;
}